// custom enums
import { Rent_Type } from "src/app/core/enums/ads/rent-types";

export const listOfRentType = [
    {name: 'يومي', id: Rent_Type.DY},
    {name: 'شهريا', id: Rent_Type.MY},
    {name: 'سنوي', id: Rent_Type.YY},
    {name: 'مفتوح', id: Rent_Type.OP},
  ]